import styled from "styled-components";

const SpanNoWrap = styled.span`
  white-space: pre; //nowrap but preserves ws and nl
  overflow: hidden;
  text-overflow: ellipsis;
`;

export default SpanNoWrap;
